<template>
  <transition name="modal">
    <div class="modal-mask-product">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="form-card__header">
            <h6 class="form-card__title">
              <i class="bi bi-plus-lg"></i>
              Nuevo pase a cuenta
            </h6>
            <button type="button" class="form-card__btn" @click="close()">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="modal-body form-card form-card--bare">
            <div class="form-card__field">
              <label class="form-card__label">Cliente</label>
              <div class="data-table__primary">{{ client.name || '...' }}</div>
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="pase-date">Fecha</label>
              <input id="pase-date" v-model="pasecuenta.date" type="date" class="form-control" required>
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="pase-type">Tipo de movimiento</label>
              <q-select
                v-model="pasecuenta.type"
                :options="[{ value: '1', label: 'Nota de débito' }, { value: '2', label: 'Nota de crédito' }]"
                placeholder="- Seleccionar tipo de movimiento -"
              />
            </div>

            <div class="form-card__field">
              <label class="pase-check" for="pase-initial">
                <input id="pase-initial" v-model="pasecuenta.initial" class="pase-check__input" type="checkbox" :true-value="1" :false-value="0">
                <span class="pase-check__text">Ingresar como saldo inicial</span>
              </label>
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="pase-amount">Monto</label>
              <input id="pase-amount" v-model.number="pasecuenta.amount" type="number" step="0.01" class="form-control" placeholder="0.00">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="pase-motive">Motivo</label>
              <input id="pase-motive" v-model.trim="pasecuenta.motive" type="text" class="form-control" placeholder="Motivo del pase">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="pase-expire">Vencimiento</label>
              <input id="pase-expire" v-model="pasecuenta.expire" type="date" class="form-control">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="pase-number">Número de comprobante</label>
              <input id="pase-number" v-model.number="pasecuenta.number" type="number" class="form-control" placeholder="N°">
            </div>
          </div>

          <div class="form-card__footer">
            <button type="button" class="form-card__btn" @click="close">Cancelar</button>
            <button
              type="button"
              class="form-card__btn form-card__btn--primary"
              :disabled="!canSave || isSaving"
              @click="savePase()"
            >
              <i class="bi bi-check-lg"></i>
              Agregar pase a cuenta
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import QSelect from '@/components/shared/QSelect.vue';

const emptyPase = (clientId) => ({
  client_id: clientId,
  date: '',
  type: '',
  motive: '',
  number: null,
  amount: null,
  expire: '',
  initial: 0,
});

export default {
  components: { QSelect },
  props: ['clientId'],
  data() {
    return {
      pasecuenta: emptyPase(this.clientId),
      client: { id: null, name: '' },
      isSaving: false,
    };
  },
  computed: {
    canSave() {
      return !!(
        this.pasecuenta.date &&
        this.pasecuenta.type &&
        this.pasecuenta.amount > 0
      );
    },
  },
  mounted() {
    this.resetForm();
    this.getClient(this.clientId);
  },
  methods: {
    getClient(id) {
      this.$http.get("/api/clients/getClient/" + id).then((response) => {
        this.client = response.data.data;
      });
    },
    savePase() {
      if (!this.canSave || this.isSaving) return;
      this.isSaving = true;
      const payload = { ...this.pasecuenta };
      if (!payload.initial) {
        delete payload.initial;
      }
      this.$http.post('/api/clients/addPase', payload).then(() => {
        this.resetForm();
        this.$emit('confirmsave');
      }).finally(() => {
        this.isSaving = false;
      });
    },
    resetForm() {
      this.pasecuenta = emptyPase(this.clientId);
    },
    close() {
      this.$emit('close');
    },
  },
  watch: {
    clientId(value) {
      if (value != null) {
        this.getClient(value);
      } else {
        this.resetForm();
      }
    },
  },
};
</script>

<style scoped>
.modal-mask-product {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 560px;
}

.modal-content {
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
  overflow: hidden;
}

.modal-body {
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 24px;
}

.pase-check {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 0;
  cursor: pointer;
}

.pase-check__input {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin: 0;
}

.pase-check__text {
  line-height: 1.2;
}

.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.02);
}
</style>
